import { GenericObject } from '~/prix/types/type'
import { GeneralPageSectionProps, InformationSchema, SchemaProps } from './types'

const customInformation = ({ item, schemas }: GeneralPageSectionProps) => {
  if (item?.phoneNumber1AreaCode && item?.phoneNumber1) {
    item.phoneNumber1 = `${item?.phoneNumber1AreaCode}${item?.phoneNumber1}`
  }
  if (item?.phoneNumber2AreaCode && item?.phoneNumber2) {
    item.phoneNumber2 = `${item?.phoneNumber2AreaCode}${item?.phoneNumber2}`
  }
  const schema: SchemaProps = {
    generalInfo: Object.keys(schemas.first),
    sectionOneInfo: Object.keys(schemas.second || {}),
    sectionTwoInfo: Object.keys(schemas.third || {}),
    sectionThreeInfo: Object.keys(schemas.fourth || {}),
  }
  const categorizedSections: { [key: string]: GenericObject } = {}
  Object.keys(item).forEach(key => {
    for (const section in schema) {
      if (schema[section].includes(key)) {
        if (!categorizedSections[section]) categorizedSections[section] = {}

        const addMetadata = (infoSchema: InformationSchema, key: string, value: any) => {
          if (infoSchema?.[key]) {
            const fieldSchema = infoSchema[key]

            // Se há formatter customizado (para campos enumerados), aplicar
            const formattedValue = fieldSchema.formatter ? fieldSchema.formatter(value) : value

            return {
              value: formattedValue,
              ...fieldSchema,
            }
          }
          return { value }
        }

        if (section === 'generalInfo') {
          categorizedSections[section][key] = addMetadata(schemas.first, key, item[key])
        } else if (section === 'sectionOneInfo' && schemas.second) {
          categorizedSections[section][key] = addMetadata(schemas.second, key, item[key])
        } else if (section === 'sectionTwoInfo' && schemas.third) {
          categorizedSections[section][key] = addMetadata(schemas.third, key, item[key])
        } else if (section === 'sectionThreeInfo' && schemas.fourth) {
          categorizedSections[section][key] = addMetadata(schemas.fourth, key, item[key])
        }
        break
      }
    }
  })
  return categorizedSections
}

export default customInformation
